/**
 * @param {{
 *   CustomizeHomepageService: ReturnType<import('../../services/CustomizeHomepageService').default>,
 * }} param0
 */
export default function customizeHomepageUseCase({ CustomizeHomepageService }) {
  const create = (payload) => {
    if (!payload) {
      throw new Error('Missing payload');
    }
    if (!payload.sectionType) {
      throw new Error('Missing sectionType in payload');
    }
    return CustomizeHomepageService.create(payload);
  };

  const get = () => {
    return CustomizeHomepageService.get();
  };

  const deleteSection = (sectionId) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    return CustomizeHomepageService.deleteSection(sectionId);
  };

  const sortSections = (sectionIds) => {
    if (!sectionIds || !Array.isArray(sectionIds)) {
      throw new Error('Missing or invalid sectionIds array');
    }
    if (sectionIds.length === 0) {
      throw new Error('Section IDs array cannot be empty');
    }
    return CustomizeHomepageService.sortSections(sectionIds);
  };

  const updateSectionActiveState = (sectionId, isActive) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    if (typeof isActive !== 'boolean') {
      throw new Error('isActive must be a boolean value');
    }
    return CustomizeHomepageService.updateSectionActiveState(sectionId, isActive);
  };

  const updateSection = (sectionId, payload) => {
    if (!sectionId) {
      throw new Error('Missing sectionId');
    }
    if (!payload) {
      throw new Error('Missing payload');
    }
    if (!payload.sectionType) {
      throw new Error('Missing sectionType in payload');
    }
    return CustomizeHomepageService.updateSection(sectionId, payload);
  };

  return {
    create,
    get,
    deleteSection,
    sortSections,
    updateSectionActiveState,
    updateSection,
  };
}
